import { render } from "./ClubDesChippies.vue?vue&type=template&id=1d610464&scoped=true"
import script from "./ClubDesChippies.vue?vue&type=script&lang=js"
export * from "./ClubDesChippies.vue?vue&type=script&lang=js"

import "./ClubDesChippies.vue?vue&type=style&index=0&id=1d610464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d610464"]])

export default __exports__